<kodit-table [tableConfig]="tableConfig" [items]="racunTable"> </kodit-table>
